const ES = {
    title: '¡Te damos la bienvenida!',
    inputs: {
        email: {
            label: 'Email',
            tip: 'Ingresá tu email registrado'
        },
        password: {
            label: 'Contraseña'
        },
    },
    forgot: {
        title: 'Olvidé mi contraseña',
        description: 'Te enviaremos un correo para ayudarte a crearla de forma simple.',
        error: 'Las credenciales ingresadas son incorrectas.<br>Por favor, intente de nuevo',
        success: 'Te mandamos un Mail para que puedas recuperar tu contraseña.'
    },
    error: 'Algunos de los datos ingresados son incorrectos.',
    userNotFound: 'El usuario no existe en nuestro sistema.',
    passwordBlocked: 'Su cuenta se encuentra bloqueada. Contacte al administrador del sistema.',
    register: {
        title: 'Crear cuenta'
    },
    general: {
        forgotButton: '¿Olvidaste tu contraseña?'
    },
    otp: {
        title: 'Ingresá el código',
        inputLabel: 'Código',
        subtitle: 'Te enviamos un código por mail, ingresalo a continuación.',
        resend: {
            question: '¿Aún no recibiste el correo?',
            action: 'Reenviar código',
            success: 'Te reenviamos el código al correo.',
            sent: 'Código reenviado',
            alreadySent: 'Te enviamos un código nuevo. Revisá tu correo.',
            notExpired: 'Tu código sigue vigente. Revisá tu correo.'
        },
        submit: 'Validar código',
        codeError: 'Algunos de los datos ingresados son incorrectos. Por favor, intente de nuevo',
        expired: 'Tu código venció. Solicitá uno nuevo para continuar.',
        emailChange: {
            success: 'Email validado con éxito'
        }
    }
};

export default ES;
